// extracted by mini-css-extract-plugin
module.exports = {"root":"ResourceLocation_root__1EQpx"};